<template>
  <div class="tableauPlaceholder" style="width: 330px; height: 1827px;">
    <object class="tableauViz" width="330" height="1827" style="display:none;">
      <param name="host_url" value="https%3A%2F%2Ftableau.bsh.de%2F" />
      <param name="embed_code_version" value="3" />
      <param name="site_root" value="" />
      <param
        name="name"
        value="Gezeitenvorausberechnung&#47;Gezeitenvorausberechnung_Einzelpegel"
      />
      <param name="tabs" value="no" />
      <param name="toolbar" value="yes" />
      <param name="filter" value="Kurzname=Leyh%C3%B6rn" />
      <param name="filter" value="Bezugsniveau=Seekartennull%20(SKN)" />
      <param
        name="filter"
        value="Zeiten=Gesetzliche%20Zeit%20(Sommer:%20MESZ%20%20%20Winter:%20MEZ)"
      />
      <param name="pixelratio" value="2" />
      <param name="showAppBanner" value="false" />
      <param name="display_count" value="no" />
      <param name="alerts" value="no" />
    </object>
  </div>
</template>

<script>
export default {
  mounted() {
    const plugin = document.createElement("script");
    plugin.setAttribute(
      "src",
      "https://tableau.bsh.de/javascripts/api/viz_v1.js'"
    );
    plugin.async = true;
    document.head.appendChild(plugin);
  }
};
</script>
